import type { CSSProperties } from 'react'
import type { GroupsBlock, PublicGroup, TrainingSlot } from '@publiqa/shared'
import { useFetch } from '../../lib/useFetch'
import { usePubliqApi } from '../context'
import { Picture } from '../ui'
import { SectionHead } from './Blocks'

const DAYS = ['', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche']
const hm = (t: string) => t.replace(':00', 'h').replace(':', 'h')

function Schedule({ slots }: { slots: TrainingSlot[] }) {
  if (!slots.length) return null
  return (
    <ul className="group-slots">
      {slots.map((s, i) => (
        <li key={i}>
          <span>{DAYS[s.weekday]}</span> {hm(s.startsAt)} – {hm(s.endsAt)}
          {s.location && <small> · {s.location}</small>}
        </li>
      ))}
    </ul>
  )
}

/**
 * Groupes d'entraînement ACTIFS, tels que gérés dans le back-office
 * (Adhérents → Groupes) : le site suit d'office les changements.
 */
export function GroupsView({ b }: { b: GroupsBlock }) {
  const path = usePubliqApi()
  const { data } = useFetch<{ season: { label: string } | null; groups: PublicGroup[] }>(
    path('/groups'),
  )
  const groups = data?.groups ?? []
  if (data && !groups.length) return null
  const tiles = b.style === 'tiles'
  const n = Math.min(Math.max(groups.length, 1), 6)
  return (
    <section className={`b-section b-features b-groups${tiles ? ' b-tiles' : ''}`}>
      <div className="container">
        <SectionHead title={b.title} intro={b.intro} />
        {/* Tous les groupes sur une ligne, comme les cotisations (moins de colonnes
            sur tablette et téléphone). */}
        <div
          className={`${tiles ? 'tiles' : 'grid'} group-row gr-${n}${n >= 4 ? ' gr-compact' : ''}`}
        >
          {groups.map((g) =>
            tiles ? (
              <article
                className="tile group-tile"
                key={g.id}
                style={{ '--group': g.color } as CSSProperties}
              >
                <Picture image={g.image} alt={g.name} className="tile-img" />
                <div className="tile-body">
                  <h3>{g.name}</h3>
                  {g.full && <span className="group-full">Complet</span>}
                  {g.description && <p>{g.description}</p>}
                  {b.showSchedule && <Schedule slots={g.slots} />}
                </div>
              </article>
            ) : (
              <article
                className={`feature group-card${g.image ? ' has-img' : ''}`}
                key={g.id}
                style={{ '--group': g.color } as CSSProperties}
              >
                {g.image && (
                  <div className="feature-media">
                    <Picture image={g.image} alt={g.name} />
                  </div>
                )}
                <div className="feature-body">
                  <h3>
                    {g.name}
                    {g.full && <span className="group-full">Complet</span>}
                  </h3>
                  {g.description && <p>{g.description}</p>}
                  {b.showSchedule && <Schedule slots={g.slots} />}
                </div>
              </article>
            ),
          )}
        </div>
      </div>
    </section>
  )
}
